import React from 'react'
import * as yup from 'yup'

import { FormattedMessage } from '@divvy-web/i18n'

import {
  accountingSoftware,
  legalBusinessName,
  numberOfEmployees,
} from '@sputnik/schema/creditApplication/businessInfo'
import { email, firstName, lastName, phoneNumber, title } from '@sputnik/schema/creditApplication/person'

export const initCreditApplication = yup.object().shape({
  firstName: firstName.required(() => (
    <FormattedMessage
      defaultMessage='Your first name is required.'
      id='sputnik.initCreditApplicationSchema__n4xR/r'
    />
  )),
  lastName: lastName.required(() => (
    <FormattedMessage
      defaultMessage='Your last name is required.'
      id='sputnik.initCreditApplicationSchema__lYhK5/'
    />
  )),
  title: title.required(() => (
    <FormattedMessage
      defaultMessage='Your role is required.'
      id='sputnik.initCreditApplicationSchema__5ByBtd'
    />
  )),
  phoneNumber: phoneNumber.required(() => (
    <FormattedMessage
      defaultMessage='Your phone number is required.'
      id='sputnik.initCreditApplicationSchema__UuXdQg'
    />
  )),
  email: email.required(() => (
    <FormattedMessage
      defaultMessage='Your email is required.'
      id='sputnik.initCreditApplicationSchema__ORTTzq'
    />
  )),
  legalBusinessName: legalBusinessName.required(() => (
    <FormattedMessage
      defaultMessage='Your legal business name is required.'
      id='sputnik.initCreditApplicationSchema__BbGE/a'
    />
  )),
  numberOfEmployees: numberOfEmployees.required(() => (
    <FormattedMessage
      defaultMessage='Number of employees is required.'
      id='sputnik.initCreditApplicationSchema__mnKf3h'
    />
  )),
  accountingSoftware: accountingSoftware.required(() => (
    <FormattedMessage
      defaultMessage='Your accounting software choice is required.'
      id='sputnik.initCreditApplicationSchema__vKIlnA'
    />
  )),
})

export type InitCreditApplication = yup.InferType<typeof initCreditApplication>
